import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { JwtHelperService } from "@auth0/angular-jwt";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { SubsidiaryContractService } from "src/app/services/http/business/subsidiary/dashboard/subsidiary-contract.service";
import { PaymentService } from "src/app/services/http/business/payment/payment.service";
import { HidService } from "src/app/services/common/hid.service";


@Component({
  selector: 'app-student-header',
  templateUrl: './student-header.component.html',
  styleUrls: ['./student-header.component.css']
})
export class StudentHeaderComponent implements OnInit {
  userInfo: any;
  nationalCode: any;
  showManagement = false;
  holdingName: string;
  showAgh = false;
  token = localStorage.getItem("token");
  wallet = 0;
  constructor(
    private router: Router,
    private holdingService: HoldingService,
    private hidService: HidService,
    private subsidiaryContractService: SubsidiaryContractService,
    private accountService: AccountService,
    private paymentService: PaymentService
  ) { }
  ngOnInit() {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(this.token);
    this.userInfo = decodedToken.fname;
    this.nationalCode = decodedToken.un;

    this.setAccess();
    this.getWallet();
    this.holdingName = this.hidService.getHIDName();
  }

  setAccess() {
    this.holdingService.list().subscribe(res => {
      if (res && res.Total)
        this.showManagement = true;
    });
    this.subsidiaryContractService.getContract(null).subscribe(
      res => {
        if (res && res.Total)
          this.showAgh = true;
      }
    );
  }

  getWallet() {
    this.paymentService.getWallet(this.nationalCode).subscribe(
      res => {
        this.wallet = res.CreditCompany;
      }
    );
  }

  logout() {
    this.accountService.logout();
  }
  NavigateToHoldingList() {
    this.router.navigate(["hbr"]);
  }

  NavigateToContractList() {
    this.router.navigate(["subsidiaryContracts"]);
  }
}
